import { render, staticRenderFns } from "./InvoiceTotals.vue?vue&type=template&id=28be83b0&"
import script from "./InvoiceTotals.vue?vue&type=script&lang=js&"
export * from "./InvoiceTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports